import React from 'react';
import './index.css';
import { Collapse, CollapseProps } from 'antd';


const { Panel } = Collapse;

interface AccordProps extends CollapseProps{
    defaultActiveKey: Array<string>;
    header: string | JSX.Element;
    children: JSX.Element;
    index: number;
}

const CustomAccordion: React.FC<AccordProps> = ({ defaultActiveKey,header,children, index, ...collapseProps }) => {
    return (
        <>
            <Collapse
                defaultActiveKey={defaultActiveKey}
                ghost
                {...collapseProps}
            >
                <Panel header={header} key={index} >
                    <div>{children}</div>
                </Panel>

            </Collapse>
        </>
    );
};

export default CustomAccordion;